"use client";
const Loading = (props) => {
    let style = {};
    if(props.color){
        style.color = props.color;
    }
    const loadingSpinner = ()  => {
        return(
            <div className="spinner-border text-primary" role="status" style={style}>
                <span className="visually-hidden">Loading...</span>
            </div>
        )
    }
    if(props.fullPage){
        return (
            <div className="loading_full_page">
                {loadingSpinner()}
            </div>
        );
    }else{
        return loadingSpinner();
    }
    
}
export default Loading;